// src/pages/Godown/MyGodowns.jsx
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import '../Team/TeamPages.css';   // reuse the team-table style

const MyGodowns = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [godowns, setGodowns] = useState(() => user?.assignedGodowns || []);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(godowns.length === 0);

  useEffect(() => {
    if (godowns.length > 0) {
      setLoading(false);
      return;
    }
    api.get('/users/me/godowns')
      .then(res => { if (res.data?.success) setGodowns(res.data.data || []); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [godowns.length]);

  const filtered = godowns.filter(g => {
    if (!search) return true;
    const s = search.toLowerCase();
    return (
      g.name?.toLowerCase().includes(s) ||
      g.location?.toLowerCase().includes(s) ||
      g.manager?.toLowerCase().includes(s)
    );
  });

  return (
    <div className="team-page-container">
      <div className="team-header">
        <h1 className="team-title">My Godowns</h1>
        <p style={{ margin: '4px 0 0 0', fontSize: 13, color: '#6c757d' }}>
          Click "View Dashboard" to open a godown's operations
        </p>
      </div>

      <div className="search-container">
        <input
          type="text"
          className="search-input"
          placeholder="Search by name, location, or manager..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {loading ? (
        <div className="loading">Loading your godowns...</div>
      ) : filtered.length === 0 ? (
        <div className="no-data">
          {search ? `No godowns matching "${search}"` : 'No godowns assigned to your account. Contact your administrator.'}
        </div>
      ) : (
        <div className="table-container">
          <table className="team-table">
            <thead>
              <tr>
                <th>#</th>
                <th>GODOWN NAME</th>
                <th>LOCATION</th>
                <th>MANAGER</th>
                <th>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((g, i) => (
                <tr key={g.id}>
                  <td>{i + 1}</td>
                  <td style={{ fontWeight: 600 }}>{g.name}</td>
                  <td>{g.location || '—'}</td>
                  <td>{g.manager || '—'}</td>
                  <td>
                    <button
                      className="pagination-btn"
                      onClick={() => navigate(`/godown/dashboard?godownId=${g.id}`)}
                    >
                      View Dashboard
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default MyGodowns;